<template>
  <div ref="mention" class="mention-popper">
    <a-modal
      :visible="isVisible"
      :footer="null"
      centered
      width="440px"
      :get-container="() => ($refs.mention as HTMLElement)"
      :closable="isStandardScreen"
      @cancel="cancelPopper"
    >
      <div class="mention-title">{{ $t('owork_base.unfinished_task_prompt_title') }}</div>
      <div class="mention-txt left">
        <p>
          {{
            isStandardScreen ? $t('owork_base.unfinished_task_prompt') : $t('owork_base.unfinished_task_prompt_message')
          }}
        </p>
      </div>
      <div class="btn-box">
        <a-button
          :type="isStandardScreen ? 'default' : 'link'"
          data-test="btn-confirm-switch-app"
          class="button leave-btn"
          @click="onOk"
          >{{ $t('owork_base.to_leave') }}</a-button
        >
        <a-divider
          v-if="!isStandardScreen"
          type="vertical"
          style="height: 20px; background-color: rgba(0, 0, 0, 0.12)"
        />
        <a-button :type="isStandardScreen ? 'primary' : 'link'" class="button color-btn" @click="cancelPopper">{{
          $t('owork_base.stay_put')
        }}</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
  import useAppSwitch from '@/core/compositions/UseAppSwitcher'
  import { useSharedScreen } from '@/core/compositions/Screen'

  const { isStandardScreen } = useSharedScreen()

  defineProps<{
    isVisible: boolean
  }>()

  const { onCloseDialog } = useAppSwitch()

  const cancelPopper = () => onCloseDialog(false)

  const onOk = () => onCloseDialog(true)
</script>

<style lang="stylus" scoped>

  .mention-popper
    .mention-txt
      margin-top 44px
      padding 0 8px
      & > p
        font-size 20px
        font-weight default_font_weight
        line-height 26px
        color default_color
    .btn-box
      margin 56px 102px 24px
      flex-align-center()
      .button
        margin-right 12px
        border-radius 8px
        &:last-child
          margin-right 0
      .color-btn
        background-color active_color

  @import '../styles/h5Adaptive/ConfirmDialog.styl'
</style>
